import { getConfig } from './default-api';
import { DEFAULT_CONFIG } from './default';

function getDomainName() {
  let parts = window.location.host.split('.');
  let domain = parts[parts.length - 1];

  if (domain.indexOf('localhost') >= 0) {
    domain = 'no';
  }

  return domain;
}

const apiMap = {
  se: 'https://api.stage.cakeiteasy.se/api',
  no: 'https://api.stage.cakeiteasy.no/api',
};

export const environment = Object.assign({},
  DEFAULT_CONFIG,
  getConfig({ baseApiUrl: apiMap[getDomainName()] }, 10 * 60 * 1000), {
    countryDomainUrls: {
      'SE': 'http://stage.cakeiteasy.se/',
      'NO': 'http://stage.cakeiteasy.no/'
    },
  },
  {
    nodeEnv: 'staging',
    isSsr: true,
    production: true,
    isServer: false,
    widget: {
      key: 'N1k8ERv1StkLRwBi',
      scriptSrc: 'https://s3.eu-central-1.amazonaws.com/cakeiteasy-widget-stage/min.js',
      enabled: true
    },
    cakesCategoryId: 1,
    cakesNameIds: {
      en: 'cakes-1',
      no: 'kaker-1',
      se: 'tartor-1'
    },
  });
